import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { generatePastelGradient } from '../utils/colorUtils';
import API_BASE from '../config';
import '../styles/Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [gradient, setGradient] = useState('');
  const navigate = useNavigate();

  useEffect(() => { setGradient(generatePastelGradient()); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setMessage('');
    try {
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(data.message);
      } else {
        setError(data.message || 'Something went wrong');
      }
    } catch {
      setError('Network error – please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" style={{ background: gradient }}>
      <div className="auth-card">
        <h1>Staff IT</h1>
        <p className="auth-slogan">Bureaucracy made simple</p>
        <h2>Reset Password</h2>

        {message ? (
          <div style={{ textAlign: 'center' }}>
            <div className="success-message" style={{ background: '#d1fae5', color: '#065f46', padding: '12px 16px', borderRadius: 6, marginBottom: 16 }}>
              {message}
            </div>
            <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Check your inbox and follow the link in the email.</p>
            <button className="btn-primary" style={{ marginTop: 16 }} onClick={() => navigate('/login')}>Back to Login</button>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}
            <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: 16 }}>
              Enter the email address linked to your account and we'll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="your.email@company.com"
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <p className="auth-toggle" style={{ marginTop: 16 }}>
              <span onClick={() => navigate('/login')} style={{ cursor: 'pointer', color: '#2563eb' }}>← Back to Login</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
